module.exports = __webpack_public_path__ + "media/images/upload-cloud-blue-icon-66c0cf4a548bc44269113283abf966ee.svg";